// extracted by mini-css-extract-plugin
export default {"sidebar_container":"Sidebar_sidebar_container__lc9UG","searchbar":"Sidebar_searchbar__upOBj","icon":"Sidebar_icon__ZKIi-","footer":"Sidebar_footer__5SsnH"};